<template>
    <div class="wiki-users-wiki-in-list" :class="{'wiki-users-wiki-in-list__in-list': inListStyle}">
        <div class="">
            <div class="wiki-users-wiki-in-list__image-part">
                <router-link :to="link" v-if="wiki.userprofile">
                    <div :style="leftAvatarStyle" v-tooltip="showOwner?wikiOwner.name:''"
                         class="wiki-users-wiki-in-list__image-part__image " alt="">
                        <div class="wiki-users-wiki-in-list__image-part__image__inner-avatar" v-if="showOwner"
                             :style="{'background-image':`url('${wikiOwner.avatar}')`}"></div>
                    </div>
                </router-link>
                <a :href="link" v-else>
                    <div :style="leftAvatarStyle" v-tooltip="showOwner?wikiOwner.name:''"
                         class="wiki-users-wiki-in-list__image-part__image" alt="">
                        <div class="wiki-users-wiki-in-list__image-part__image__inner-avatar" v-if="showOwner"
                             :style="{'background-image':`url('${wikiOwner.avatar}')`}"></div>
                    </div>
                </a>
            </div>
            <div class="wiki-users-wiki-in-list__content-part">
                <div class="wiki-users-wiki-in-list__content-part__user-info" :class="{'full-width':showOwner}">
                    <div class="wiki-users-wiki-in-list__content-part__user-info__wiki-name">
                        <router-link :to="link" v-if="wiki.userprofile">
                            {{ wiki.name }}
                        </router-link>
                        <a :href="link" v-else>
                            {{ wiki.name }}
                        </a>
                    </div>
                    <div v-if="wiki.logo">
                        <img
                                alt="Logo"
                                class="logo-image"
                                :height="40"
                                :src="wiki.logo"
                        >
                    </div>
                    <div class="wiki-users-wiki-in-list__content-part__user-info__description" v-if="wiki.description">
                        {{ wiki.description|cutName(150) }}
                    </div>
                </div>
            </div>
        </div>
        <div class="wiki-users-wiki-in-list__expand-link-section"
             v-if="hiddenManagedWikisCount&&!otherWikisIManage.length"
        >
            <span class="wiki-users-wiki-in-list__expand-link"
                  @click="loadMoreManagedWikis"
                  tabindex="0"
                  role="button"
                  aria-label="Show More"
            >
                <i class="fa fa-chevron-double-down"></i>Show {{ hiddenManagedWikisCount }} More<i
                    class="fa fa-chevron-double-down"></i>
            </span>
        </div>
        <div class="" v-if="otherWikisIManage.length">
            <wikis-shared-list-wiki
                    v-for="wiki in otherWikisIManage"
                    :wiki="wiki"
                    :key="wiki.id"
                    :show-owner="false"
                    in-list-style
            ></wikis-shared-list-wiki>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import urls from 'DjangoUrls';
    import WikisListResource from "../wiki/wikis_list_resource";

    let {DjangoUrls} = urls;

    export default {
        props: {
            wiki: {
                type: Object
            },
            templateActions: {
                type: Boolean,
                default: false
            },
            showOwner: {
                type: Boolean,
                default: true
            },
            inListStyle: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                otherWikisIManage: [],
            };
        },
        computed: {
            hiddenManagedWikisCount() {
                if (this.wiki.managed_wikis_count) {
                    return this.wiki.managed_wikis_count - 1;
                }
            },
            leftAvatarStyle() {
                let avatarUrl;
                // if (this.showOwner) {
                //     avatarUrl = this.wikiOwner.avatar;
                // } else {
                avatarUrl = this.wiki.avatar;
                // }
                return {
                    'background-image': `url('${avatarUrl}')`,

                };
            },
            templateName() {
                if (!this.wiki.template) {
                    return 'Custom';
                }
                return this.wiki.template.name;
            },
            wikiOwner() {
                return this.wiki.userprofile || this.wiki.community;
            },
            link() {
                return `${this.wiki.link}?fl=1`;
            },

        },
        methods: {
            loadMoreManagedWikis() {
                const $http = Vue.getAngularModule('$http');
                const $rootScope = Vue.getAngularModule('$rootScope');
                $rootScope.show_dimmer();
                WikisListResource($http).load_more_users_wikis_i_manage(this.wiki.userprofile.id, this.wiki.id)
                    .then(resp => {
                        this.otherWikisIManage = resp.data;
                    }, err => {
                        Vue.notificationserror(err || 'Error');
                    })
                    .finally($rootScope.hide_dimmer);
            }
        },
        name: "WikisSharedListWiki"
    };
</script>

<style scoped lang="scss">
  @import "../styles/mixins.scss";
  @import "../styles/const";

  .logo-image{
    border-radius: 5px;
  }

  .wiki-users-wiki-in-list {
    @include managedUserInList();

    &__in-list {
      margin: 0;
      border: none;
      border-radius: 0;
      border-top: 1px solid $gray;
    }

    &__expand-link-section {
      font-size: 16px;
      text-align: center;
      font-weight: bolder;
    }

    &__expand-link {
      cursor: pointer;
    }

    &__image-part {
      &__image {
        background-repeat: no-repeat;
        background-size: contain;
        border-radius: 50%;
        height: 120px;
        width: 120px;
        display: inline-block;
        background-color: #fff;
        position: relative;

        &__inner-avatar {
          background-color: #fff;
          position: absolute;
          top: 0;
          left: 0;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background-repeat: no-repeat;
          background-size: contain;
          border: 3px solid #fff;
        }
      }
    }

    &__content-part {
      font-size: 0;

      &__wiki-image {
        display: inline-block;
        width: 110px;
        @media all and (max-width: 549px) {
          vertical-align: top;
        }
        @media all and (min-width: 550px) {
          vertical-align: top;
        }

        &__image {
          width: 100px;
        }
      }

      &__user-info {
        @media all and (max-width: 549px) {
          padding-left: 5px;
        }
        @media all and (min-width: 550px) {
          padding-left: 15px;
        }

        font-size: $header-font-size;

        /*&.full-width {*/
        width: 100%;
        /*}*/
        /**/
        /*max-width: calc(100% - 110px);*/
        display: inline-block;

        &__wiki-name {
          font-size: 22px;
        }

        @media all and (max-width: 549px) {
          vertical-align: top;
        }
        @media all and (min-width: 550px) {
          vertical-align: top;
        }

        &__name {
          font-weight: normal;
          font-size: 18px;
        }

        &__template-actions {
          font-weight: normal;
          font-size: 18px;
        }

        &__description {
          font-size: $bigger-font-size;
          font-style: italic;
          font-weight: normal;

          &__label {
            font-style: normal;
          }
        }
      }
    }
  }

</style>
